import { useState } from "react";
import { WHATSAPP_LINK } from "@/pages/home/constants";

export const FAQ_ITEMS = [
  {
    question: "Quanto custa um passeio de lancha em Capitólio?",
    answer:
      "O passeio de lancha compartilhado em Capitólio começa em R$ 100 por pessoa, e o passeio exclusivo (privativo) a partir de R$ 700 por lancha. Os valores podem variar conforme o roteiro, o número de pessoas e a temporada — fale com a nossa equipe pelo WhatsApp para confirmar o valor atualizado do seu passeio.",
  },
  {
    question: "Quanto tempo dura o passeio de lancha?",
    answer:
      "O passeio compartilhado dura cerca de 3 horas navegando pelo Lago de Furnas. Já no passeio de lancha exclusivo em Capitólio o tempo é definido por você, conforme o roteiro escolhido pela sua família ou grupo.",
  },
  {
    question: "Onde fica o ponto de embarque?",
    answer:
      "O embarque acontece no Complexo Furnas Aventura, à beira do Lago de Furnas, em Capitólio (MG). O local conta com estacionamento gratuito, vestiário amplo e infraestrutura completa para você embarcar com tranquilidade.",
  },
  {
    question: "Quais lugares o passeio visita?",
    answer:
      "O roteiro de lancha em Capitólio passa pelos Cânions de Capitólio, pela Lagoa Azul, pelo Vale dos Tucanos, pela Cachoeira da Gruta e pelos bares flutuantes do Lago de Furnas, e inclui parada para banho na Cachoeira das Orquídeas, nas águas do Mar de Minas.",
  },
  {
    question: "O passeio é compartilhado ou exclusivo?",
    answer:
      "Oferecemos as duas opções. No passeio compartilhado você divide a lancha com outros turistas e paga por pessoa. No passeio exclusivo a lancha é privativa para o seu grupo, com roteiro e horário personalizados.",
  },
  {
    question: "Vocês fazem aluguel de lancha em Capitólio?",
    answer:
      "Sim. Além dos passeios compartilhados e exclusivos, a Eco Tour Turismo faz aluguel e locação de lancha em Capitólio para grupos de 12 a 19 passageiros, com ou sem marinheiro, por meio período ou dia inteiro. O roteiro é montado por você junto com a nossa equipe, passando pelos pontos que quiser no Lago de Furnas.",
  },
  {
    question: "Quantas pessoas cabem nas lanchas?",
    answer:
      "Nossa frota vai de 12 a 19 passageiros: Luna (12 passageiros), Lake Hunter (14 passageiros), Vall (15 passageiros) e Dream Sea (19 passageiros, com banheiro a bordo). Há lancha ideal para famílias, casais e grupos maiores.",
  },
  {
    question: "O passeio passa pelos Cânions de Capitólio?",
    answer:
      "Sim. Os imponentes paredões dos Cânions de Capitólio fazem parte do nosso roteiro e rendem as fotos mais bonitas do passeio de lancha no Lago de Furnas.",
  },
  {
    question: "O passeio passa pela Lagoa Azul?",
    answer:
      "Sim, a Lagoa Azul é um dos destaques do roteiro, com suas águas cristalinas em tom azul-turquesa que são um dos cartões-postais de Capitólio.",
  },
  {
    question: "Existe passeio de jet ski em Capitólio?",
    answer:
      "Sim! Além das lanchas, a Eco Tour Turismo oferece passeio guiado e aluguel de jet ski no Lago de Furnas, no coração do Mar de Minas, com instrutor e paradas para fotos.",
  },
  {
    question: "Como faço para reservar?",
    answer:
      "É simples: fale com a Eco Tour Turismo pelo WhatsApp, informe a data, o número de pessoas e a experiência desejada. Nossa equipe confirma a disponibilidade e todos os detalhes do seu passeio de lancha em Capitólio.",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="relative py-7 md:py-12 bg-background-100 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-[1100px] mx-auto">
          <div className="text-center mb-5 md:mb-8 reveal">
            <span className="inline-block text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em] text-accent-700 mb-3">
              Dúvidas frequentes
            </span>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-primary-900 mb-3">
              Perguntas Frequentes sobre os Passeios em Capitólio
            </h2>
            <p className="text-xs md:text-sm text-foreground-600 max-w-xl mx-auto">
              Tudo o que você precisa saber antes de reservar o seu passeio de lancha no Lago de Furnas.
            </p>
          </div>

          <div className="space-y-2.5 reveal">
            {FAQ_ITEMS.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.question}
                  className="rounded-lg border border-background-200/80 bg-background-50 overflow-hidden transition-colors duration-200"
                >
                  <h3 className="m-0">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 text-left px-4 md:px-5 py-4 cursor-pointer"
                    >
                      <span className="text-sm md:text-base font-heading font-semibold text-primary-900">
                        {item.question}
                      </span>
                      <span
                        className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                          isOpen ? "bg-accent-500 text-primary-950" : "bg-primary-100 text-primary-700"
                        }`}
                      >
                        <i className={`text-base ${isOpen ? "ri-subtract-line" : "ri-add-line"}`} />
                      </span>
                    </button>
                  </h3>
                  <div
                    className={`grid transition-all duration-300 ease-in-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-4 md:px-5 pb-4 text-xs md:text-sm text-foreground-600 leading-relaxed">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="text-center mt-6 reveal">
            <a
              href={WHATSAPP_LINK}
              data-whatsapp-cta
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-bold bg-accent-500 text-primary-950 hover:bg-accent-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg" />
              Tem outra dúvida? Fale com a Eco Tour
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}